export enum MenuBarItemEnum {
  Vehicles = 'vehicles',
  Offers = 'offers',
  Admin = 'admin'
}
